import Vue from 'vue'
import Router from 'vue-router'
import GMap from '@/components/home/GMap'
import Signup from '@/components/auth/Signup'
import Login from '@/components/auth/Login'
import firebase from 'firebase'
import ViewProfile from '@/components/profile/ViewProfile'

Vue.use(Router)

const router =  new Router({
  mode: 'history', // so that not to have slashes inurl
  routes: [
    {
      path: '/',
      name: 'GMap',
      component: GMap,
      meta: {requiresAuth: true}
    },
    {
      path:'/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path:'/login',
      name:'Login',
      component: Login
    },
    {
      path:'/profile/:id',
      name: 'ViewProfile',
      component: ViewProfile,
      meta: {requiresAuth: true}
    }
  ]
})
// apply route guard before each route so i created a constant called router to play with it
router.beforeEach((to,from,next)=>{
  //check if the route going to require authentication
  if(to.matched.some(rec => rec.meta.requiresAuth)){
    //check if current user has already signed up which means check auth state of user
    let user = firebase.auth().currentUser
    //if user signed in then proceed to route
    if(user) {
      next()
    } else {
      //no user signed in, redirect to login
      next({name:'Login'})
    } 
  } else {
    next() //proceed to next as usual
  }
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js